  import { lazy } from "react";
  


  import {AuthGuard,AuthGuardAdmin} from "./auth/AuthGuard";
 

  import Loadable from "./components/Loadable";
  import MatxLayout from "./components/MatxLayout/MatxLayout";

  import materialRoutes from "app/views/material-kit/MaterialRoutes";
  import AdminRoutes from "./Admin/AdminRoutes";
  import { element } from "prop-types";
  import AdminDashboard from "./Admin/AdminDashboard";


  // SESSION PAGES
  const NotFound = Loadable(lazy(() => import("app/views/sessions/NotFound")));
  const JwtLogin = Loadable(lazy(() => import("app/views/sessions/JwtLogin")));
  const ForgatePassword = Loadable(lazy(() => import("app/views/sessions/forgatePassword")))
  // E-CHART PAGE
  const AppEchart = Loadable(lazy(() => import("app/views/charts/echarts/AppEchart")));
  // DASHBOARD PAGE
  const Analytics = Loadable(lazy(() => import("app/views/dashboard/Analytics")));
  const ThankYouPage = Loadable(lazy(() => import("app/Admin/vendor/all_vendor/Vendor/Thankyoupage")));
  const ErrorPage = Loadable(lazy(() => import("app/Admin/vendor/all_vendor/Vendor/Error")));

  const routes = [
    {
      element: (
        <AuthGuard>
          <MatxLayout />
        </AuthGuard>
      ),
      children: [
        ...materialRoutes,
        // dashboard route
        { path: "/dashboard/default", element: <Analytics /> },
        // e-chart route
        { path: "/charts", element: <AppEchart /> }
      ]
    },
    
    {
      element: (
        <AuthGuardAdmin>
          <MatxLayout />
        </AuthGuardAdmin>
      ),
      children: [
        ...AdminRoutes,
        { path: "/admin", element: <AdminDashboard /> },
       
        ]
    },


    // session pages route
    // { path: "/session/404", element: <NotFound /> },
    { path: "/", element: <JwtLogin /> },
    { path: "/", element: <JwtLogin /> },
    { path: "/forgot-password", element: <ForgatePassword/> },
  
  
    { path: "/thank-you", element: <ThankYouPage /> },
    { path: "/stripe-fail", element: <ErrorPage /> },
    { path: "*", element: <NotFound /> },
  ];

  export default routes;
